import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { AppProvider } from "./context/AppContext";
import ProtectedRoute from "./utils/ProtectedRoute";
import TenantRoute from "./utils/TenantRoute";
import DashboardLayout from "./layouts/DashboardLayout";
import Login from "./pages/Login";
import MobileAuth from "./pages/MobileAuth";
import Overview from "./pages/Overview";
import Products from "./pages/Products";
import IncomingOrders from "./pages/IncomingOrders";
import Categories from "./pages/Categories";
import Profile from "./pages/Profile";
import Notifications from "./pages/Notifications";
import Pricing from "./pages/Pricing";
import PaymentCallback from "./pages/PaymentCallback";
import ManagePlan from "./pages/ManagePlan";
import TenantProperty from "./pages/TenantProperty";
import Marketplace from "./pages/Marketplace";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<Login />} />

              {/* Mobile-app bridge: /auth?token=BEARER validates and redirects */}
              <Route path="/auth" element={<MobileAuth />} />

              {/* Payment callback after Paystack checkout */}
              <Route
                path="/payment/callback"
                element={
                  <ProtectedRoute>
                    <PaymentCallback />
                  </ProtectedRoute>
                }
              />

              {/* Tenant-only: property management screen */}
              <Route
                path="/tenant"
                element={
                  <TenantRoute>
                    <TenantProperty />
                  </TenantRoute>
                }
              />

              {/* Protected dashboard (both roles) */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }>
                <Route index element={<Overview />} />
                <Route path="products" element={<Products />} />
                <Route path="incoming-orders" element={<IncomingOrders />} />
                <Route path="categories" element={<Categories />} />
                <Route path="profile" element={<Profile />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="manage-plan" element={<ManagePlan />} />
                <Route path="marketplace" element={<Marketplace />} />
              </Route>

              {/* Public: Privacy Policy (must be accessible without auth for Play Store) */}
              <Route path="/privacy" element={<PrivacyPolicy />} />

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </BrowserRouter>
        </AppProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
